import { useLocation, useNavigate } from "react-router-dom";
import { retrunAssets } from "../utils/getAssets";
import useFetch from "../utils/useFetch";
import { DecodeHtml } from "../utils/decodeHtml";
import TabsPage from "../components/tabsPage";
import AnimatedPage from "../components/animatedPage";
import Banner from "../components/banner/banner";
import TabHeaders from "../components/campusLife/tabHeaders";
import Contents from "../components/campusLife/tabContents";
import { useEffect, useMemo, useState } from "react";

const GlobalExchange = () => {
  const base = "student-hub/";
  const navigate = useNavigate();

  const state1 = useFetch(base + "about-360-gem/");
  const state2 = useFetch(base + "upcoming-360-gem/");
  const state3 = useFetch(base + "apply-360-gem/");
  const state4 = useFetch(base + "contact-us-360-gem/");

  const data1 = state1?.properties;
  const data2 = state2?.properties;
  const data3 = state3?.properties;
  const data4 = state4?.properties;
  const location = useLocation();
  const queryParams = useMemo(() => new URLSearchParams(location.search), [location.search]);
  const defaultActiveTab = parseInt(queryParams.get('tab')) || 0;
  const [activeTab, setActiveTab] = useState(defaultActiveTab);


  useEffect(() => {
    if (activeTab == 4) {
      navigate("/international office");
    }
  }, [activeTab])


  const handleTabClick = (index) => {

    setActiveTab(index);
    queryParams.set('tab', index);
    navigate({ search: queryParams.toString() });
  };

  const title = data1?.title;
  const bg = data1?.backgroundImage != null ? retrunAssets(data1?.backgroundImage[0]?.url) : "";
  // const imageCarousel = data1?.imageCarousel?.map(item => retrunAssets(item?.url));
  const headers = ["About 360 GEM", "Upcoming 360 GEM", "Apply 360 GEM", "Contact Us", "International Office"];

  const data = [
    {
      header: headers[0],
      content: DecodeHtml({ html: data1?.contents?.markup })
    },
    {
      header: headers[1],
      content: DecodeHtml({ html: data2?.contents?.markup })
    },
    {
      header: headers[2],
      content: DecodeHtml({ html: data3?.contents?.markup })
    },
    {
      header: headers[3],
      content: DecodeHtml({ html: data4?.contents?.markup })
    },
    {
      header: headers[4],
      content: null
    }

  ]

  return (
    <AnimatedPage>
      <Banner text={title} bg={bg} />
      <div className="flex justify-center w-full p-8 md:p-12">
        <div className="w-full lg:max-w-7xl">
          <div className="w-full relative  flex flex-col ">
            <div className="flex w-full bg-cover bg-no-repeat bg-center pt-4 rounded-lg" style={{ backgroundImage: `url(${bg})` }} >

              <TabHeaders headers={data?.map(item => item.header)} activeTab={activeTab} handleTabClick={handleTabClick} />
            </div>
            <Contents contents={data?.map(tab => tab.content)} activeTab={activeTab} />
          </div>

        </div>

      </div>
    </AnimatedPage>
  );
};

export default GlobalExchange;
